module.exports = __webpack_public_path__ + "static/taleny@2x-9c622c17b96200b3881ace4b25e91e87.png";